var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', [_c('loading-overlay'), _vm._v(" "), _c('button', {
    staticClass: "text-lg button--filled button--mint",
    on: {
      "click": _vm.onButton
    }
  }, [_vm._v("\n\t\tContinue in the app\n\t")]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-white.svg"),
      "alt": "Extra logo"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };